import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Welcome from './pages/welcome/Welcome';
import PathSelection from './pages/pathSelection/PathSelection';
import Students from './pages/allStudents/Students';
import LoginPage from './pages/login/Login';
import Create from './pages/create/Create';
import CreateAdmin from './pages/CreateAdmin/CreateAdmin';
import Edit from './pages/edit/edit';
import ContractContent from './pages/contractContent/contractContent';
import Signature from './pages/signature/Signature';
import ProtectedRoute from './common/protectRoute';
import SuperAdminRoute from './common/SuperAdminRoute';
import Settings from './pages/settings/Settings';
// import SendContract from "./pages/sendContract/SendContract";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/path-selection" element={<PathSelection />} />
        <Route path="/loginforadmin" element={<LoginPage />} />
        <Route path="/create" element={<Create />} />
        <Route path="/signature/:contractId" element={<Signature />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/students" element={<Students />} />
          <Route path="/edit-contract/:id" element={<Edit />} />
          <Route element={<SuperAdminRoute />}>
            <Route path="/create-admin" element={<CreateAdmin />} />
            <Route path="/settings" element={<Settings />} />
            <Route
              path="/edit-contract-content"
              element={<ContractContent />}
            />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
